// extracted by extract-css-chunks-webpack-plugin
module.exports = {"buttons":"_1Rtiw","left":"_2c4cZ","button":"_3LyjS","postpone":"_1Euty","delete":"WrNtz","save":"WDo7P"};